var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41015 16.75C4.17015 19.64 6.35015 22 9.25015 22H14.0402C17.3002 22 19.5402 19.37 19.0002 16.15C18.4302 12.77 15.1702 10 11.7402 10C8.02015 10 4.72015 13.04 4.41015 16.75Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4702 7.5C11.8509 7.5 12.9702 6.38071 12.9702 5C12.9702 3.61929 11.8509 2.5 10.4702 2.5C9.0895 2.5 7.97021 3.61929 7.97021 5C7.97021 6.38071 9.0895 7.5 10.4702 7.5Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 8.7002C18.4044 8.7002 19.2998 7.80476 19.2998 6.7002C19.2998 5.59563 18.4044 4.7002 17.2998 4.7002C16.1952 4.7002 15.2998 5.59563 15.2998 6.7002C15.2998 7.80476 16.1952 8.7002 17.2998 8.7002Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.7002C21.8284 12.7002 22.5 12.0286 22.5 11.2002C22.5 10.3718 21.8284 9.7002 21 9.7002C20.1716 9.7002 19.5 10.3718 19.5 11.2002C19.5 12.0286 20.1716 12.7002 21 12.7002Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97021 10.7002C5.07478 10.7002 5.97021 9.80476 5.97021 8.7002C5.97021 7.59563 5.07478 6.7002 3.97021 6.7002C2.86565 6.7002 1.97021 7.59563 1.97021 8.7002C1.97021 9.80476 2.86565 10.7002 3.97021 10.7002Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.21898cc404d8d44115f02070ea636bd9.svg";
export { ForwardRef as ReactComponent };